<template>
  <b-col md="12">
    <section class="codes-refer">
      <p class="codes-refer__title">Codici e Riferimenti</p>
      <div class="codes-refer__info">
        <p v-if="double_checked">Numero della prenotazione: <strong>{{ confirm.epsVoucher.itinerary_id }}</strong></p>
        <p>Codice di conferma: <strong>{{ confirm.epsVoucher.confirmcode }}</strong></p>
        <p>Persona di riferimento: <strong>{{ confirm.epsVoucher.displayName }}</strong></p>
        <p>Email: <strong>{{ confirm.epsVoucher.email }}</strong></p>
      </div>
    </section>
  </b-col>
</template>

<script>

export default {
  inheritAttrs: false,
  name: 'codes-references',

  components: {
  },

  props: {
    double_checked: Boolean,
    confirm: Object
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .codes-refer {
    background-color: $selected;
    border-radius: $border-radius-lg * 2;
    padding: $grid-gutter-20;
    border: 1px solid $gray-300;
    margin-top: $grid-gutter-width;

    &__title {
      font-size: $font-size-lg;
      font-weight: $vb-font-weight-semibold;
      margin-bottom: $grid-gutter-width / 3;
    }

    &__info {
      p {
        margin-bottom: $grid-gutter-width / 6;
      }
      strong {
        font-weight: $vb-font-weight-semibold;
      }
    }
  }

</style>